/* eslint-disable no-console */
/**
 * 统一日志模块
 *
 * 开发环境通过 console 输出日志，生产环境静默。
 * 使用 import.meta.env.DEV 判断环境。
 */

export const logger = {
  /**
   * 输出调试信息（仅开发环境）
   */
  debug(message: string, ...args: unknown[]): void {
    if (import.meta.env.DEV) {
      console.log(`[Debug] ${message}`, ...args)
    }
  },

  /**
   * 输出警告信息（仅开发环境）
   */
  warn(message: string, ...args: unknown[]): void {
    if (import.meta.env.DEV) {
      console.warn(`[Warn] ${message}`, ...args)
    }
  },

  /**
   * 输出错误信息（仅开发环境）
   */
  error(message: string, ...args: unknown[]): void {
    if (import.meta.env.DEV) {
      console.error(`[Error] ${message}`, ...args)
    }
  }
}
